import React, {Component} from "react";

import Header from "../../../Containers/Header/Header";
import Footer from "../../../Containers/Footer";

import AdminVocab from "./AdminVocab";
import AdminAuthority from "./AdminAuthority";
import AdminReading from "./AdminReading";

const initialState = {
    categoryGradeList: [],
    categorySectionList: [],
    categoryTitleList: [],
}

class AdminSystem extends Component {
    state = {
        tabList: [
            {id: 0, text: "단어 저장", checked: true},
            {id: 1, text: "읽기 저장", checked: false},
            {id: 2, text: "권한 관리", checked: false},
        ],
        tabIndex: 0
    }

    setTabButton = () => {
        const {tabList} = this.state;
        return (
            <div className="list-btn">
                {tabList.map(
                    ({id, text, checked}) => (
                        <a key={id} className={(checked) ? "active" : ""}
                           onClick={() => this.onClickTabButton(id)}>{text}</a>
                    )
                )}
            </div>
        );
    }

    onClickTabButton = (id) => {
        const {tabList} = this.state;
        const index = tabList.findIndex(item => item.id === id);
        const changeList = [...tabList];
        changeList.map((item) => item.checked = (item.id === index));

        this.setState({
            tabList: changeList,
            tabIndex: index
        });
    }

    render() {
        const {tabIndex} = this.state;

        return (
            <div className="beaconWrapper">
                {/*<PopupVocabUpload active={popupVocabUploadShow} onSubmit={this.onSubmit}/>*/}
                <Header selectedIndex={2}/>
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <div className="adminWrapper">
                            {this.setTabButton()}
                            {
                                (tabIndex === 0) ? <AdminVocab/> :
                                (tabIndex === 1) ? <AdminReading/> : <AdminAuthority/>
                            }
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>

        );
    }
}

export default AdminSystem;



// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminSystem/index.js